import { createFileRoute, redirect } from '@tanstack/react-router';
import ShipLoading from '@/components/ui/loader/ShipLoading';

export default function ReportIndex() {
  return (
    <div className="w-full flex items-center justify-center min-h-[50vh]">
      <ShipLoading label="Memuat laporan..." />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/report/history' });
  },
  component: ReportIndex,
});
